var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnnouncement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "announcement_svg__a",
    width: 29,
    height: 29,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h29v29H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#announcement_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.75 15.708v-2.416h4.833v2.416zm1.45 8.459-3.867-2.9 1.45-1.934 3.867 2.9zm-2.417-14.5-1.45-1.934 3.867-2.9 1.45 1.934zM6.041 22.958v-4.833H4.833a2.33 2.33 0 0 1-1.707-.71 2.33 2.33 0 0 1-.71-1.707v-2.416q0-.998.71-1.707a2.33 2.33 0 0 1 1.707-.71h4.833l6.042-3.625v14.5l-6.042-3.625H8.458v4.833zm7.25-5.498v-5.92l-2.96 1.752H4.833v2.416h5.498zm3.625 1.088v-8.096a5.5 5.5 0 0 1 1.315 1.767q.498 1.042.498 2.281t-.498 2.28a5.5 5.5 0 0 1-1.315 1.768"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnnouncement);
export default ForwardRef;